import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class MeasurementsForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Weight (g)"
              name="weight"
              serverError={this.props.errors.weight}
              component={TextInputField}
              normalize={numerical}
              />
            <Field 
              label="Width (mm)"
              name="width"
              serverError={this.props.errors.width}
              component={TextInputField}
              normalize={numerical}
              />
            <Field 
              label="Height (mm)"
              name="height"
              serverError={this.props.errors.height}
              component={TextInputField}
              normalize={numerical}
              />
            <Field 
              label="Depth (mm)"
              name="depth"
              serverError={this.props.errors.depth}
              component={TextInputField}
              normalize={numerical}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "MeasurementsForm"
})(MeasurementsForm);

export default ReduxForm;